<template>
  <div style="position: relative;">
    <el-form ref="dailyOnlineDurationListFilter" :model="dailyOnlineDurationList" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="记录日期" prop="formFilter.opTime">
          <date-range class="filter-item" v-model="dailyOnlineDurationList.formFilter.opTime" :clearable="true" :allowTypes="['day']" align="left"
            range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-form-item label="名称" prop="formFilter.specialistName">
          <el-input class="filter-item" v-model="dailyOnlineDurationList.formFilter.specialistName"
            :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="类型" prop="formFilter.specialistType">
          <el-select class="filter-item" v-model="dailyOnlineDurationList.formFilter.specialistType" :clearable="true" filterable
                     placeholder="" :loading="dailyOnlineDurationList.specialistType.impl.loading"
                     @visible-change="dailyOnlineDurationList.specialistType.impl.onVisibleChange"
                     >
            <el-option v-for="item in dailyOnlineDurationList.specialistType.impl.dropdownList" :key="item.id"
                       :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetDailyOnlineDurationList">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshDailyOnlineDurationList(true)">查询</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('dailyOnlineDurationList:dailyOnlineDurationList:export')"
          @click="onExportClick()">
          导出
        </el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="onlineDurationRecord" :data="dailyOnlineDurationList.OnlineDurationRecord.impl.dataList" :size="defaultFormItemSize" @sort-change="dailyOnlineDurationList.OnlineDurationRecord.impl.onSortChange"
          header-cell-class-name="table-header-gray"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="dailyOnlineDurationList.OnlineDurationRecord.impl.getTableIndex" />
          <el-table-column label="专家名称" prop="specialistName">
          </el-table-column>
          <el-table-column label="类型" prop="specialistTypeDictMap.name">
          </el-table-column>
          <el-table-column label="时长" prop="duration">
          </el-table-column>
          <el-table-column label="记录日期" prop="recordDate">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.recordDate, 'day')}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="dailyOnlineDurationList.OnlineDurationRecord.impl.totalCount"
            :current-page="dailyOnlineDurationList.OnlineDurationRecord.impl.currentPage"
            :page-size="dailyOnlineDurationList.OnlineDurationRecord.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="dailyOnlineDurationList.OnlineDurationRecord.impl.onCurrentPageChange"
            @size-change="dailyOnlineDurationList.OnlineDurationRecord.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { OnlineDurationRecordController, DictionaryController } from '@/api';

export default {
  name: 'dailyOnlineDurationList',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      dailyOnlineDurationList: {
        formFilter: {
          opTime: [],
          specialistType: undefined,
          specialistName: undefined
        },
        formFilterCopy: {
          opTime: [],
          specialistType: undefined,
          specialistName: undefined
        },
        specialistType: {
          impl: new DropdownWidget(this.loadSpecialistTypeDropdownList)
        },
        OnlineDurationRecord: {
          impl: new TableWidget(this.loadOnlineDurationRecordWidgetData, this.loadOnlineDurationRecordVerify, true, false)
        },
        isInit: false
      }
    }
  },
  methods: {
    loadSpecialistTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSpecialistTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    onResetDailyOnlineDurationList () {
      this.$refs.dailyOnlineDurationListFilter.resetFields();
      this.refreshDailyOnlineDurationList(true);
    },
    /**
     * 在线时长记录数据获取函数，返回Promise
     */
    loadOnlineDurationRecordWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        onlineDurationRecordDtoFilter: {
          specialistName: this.dailyOnlineDurationList.formFilterCopy.specialistName,
          specialistType: this.dailyOnlineDurationList.formFilterCopy.specialistType,
          recordDateStart: Array.isArray(this.dailyOnlineDurationList.formFilterCopy.opTime) ? this.dailyOnlineDurationList.formFilterCopy.opTime[0] : undefined,
          recordDateEnd: Array.isArray(this.dailyOnlineDurationList.formFilterCopy.opTime) ? this.dailyOnlineDurationList.formFilterCopy.opTime[1] : undefined
        },
        orderParam: [
          {
            fieldName: 'recordDate',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        OnlineDurationRecordController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 在线时长记录数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadOnlineDurationRecordVerify () {
      this.dailyOnlineDurationList.formFilterCopy.specialistName = this.dailyOnlineDurationList.formFilter.specialistName;
      this.dailyOnlineDurationList.formFilterCopy.opTime = this.dailyOnlineDurationList.formFilter.opTime;
      this.dailyOnlineDurationList.formFilterCopy.specialistType = this.dailyOnlineDurationList.formFilter.specialistType;

      return true;
    },
    /**
     * 更新专家日常在线时长列表
     */
    refreshDailyOnlineDurationList (reloadData = false) {
      if (reloadData) {
        this.dailyOnlineDurationList.OnlineDurationRecord.impl.refreshTable(true, 1);
      } else {
        this.dailyOnlineDurationList.OnlineDurationRecord.impl.refreshTable();
      }
      if (!this.dailyOnlineDurationList.isInit) {
        // 初始化下拉数据
      }
      this.dailyOnlineDurationList.isInit = true;
    },
    /**
     * 导出
     */
    onExportClick () {
      let params = {
        onlineDurationRecordDtoFilter: {
          specialistName: this.dailyOnlineDurationList.formFilterCopy.specialistName,
          specialistType: this.dailyOnlineDurationList.formFilterCopy.specialistType,
          recordDateStart: Array.isArray(this.dailyOnlineDurationList.formFilterCopy.opTime) ? this.dailyOnlineDurationList.formFilterCopy.opTime[0] : undefined,
          recordDateEnd: Array.isArray(this.dailyOnlineDurationList.formFilterCopy.opTime) ? this.dailyOnlineDurationList.formFilterCopy.opTime[1] : undefined
        }
      };

      OnlineDurationRecordController.export(this, params, '在线时长记录.xlsx').then(res => {
        this.$message.success('导出成功');
      }).catch(e => {
        this.$message.error(e.errorMessage);
      });
    },
    onResume () {
      this.refreshDailyOnlineDurationList();
    },
    initFormData () {
    },
    formInit () {
      this.refreshDailyOnlineDurationList();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
